import React from 'react';
import styled from 'styled-components';
import { ReferenceLine, ComposedChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

import TooltipContent from "../../../../components/ceo/analysis/competitive/charts/tooltip-content";

const ChartContainer = styled.div`
  padding: 20px;
  font-family: 'Mukta Vaani';

  > h3 {
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > p {
    font-family: 'Roboto';
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 1px;
    color: rgba(0, 27, 59, 0.6);
    text-align: right;
  }
`;

const ComposedGradientChart = ({
  title,
  data,
  lineData,
  suffix = ""
}) => {
  const convertValue = value => `${value}${suffix}`;

  const increasingChartData = data.sort(({ value: a }, { value: b }) => a - b);

  return (
    <ChartContainer>
      <h3>{title}</h3>
      <ComposedChart width={650} height={200} data={increasingChartData} margin={{ top: 10, right: 30, left: 0, bottom: 3 }}>
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="75%" stopColor="#CCBDFA" stopOpacity={1} />
            <stop offset="100%" stopColor="#FFFFFF" stopOpacity={1} />
          </linearGradient>
        </defs>
        <XAxis hide={true} />
        <YAxis
          tickFormatter={convertValue}
          axisLine={false}
          tickLine={false}
          domain={[
            dataMin => dataMin < lineData
              ? dataMin === 0 ? -0.5 :
                dataMin > 0
                  ? Math.round(dataMin * 100 * 0.9) / 100
                  : Math.round(dataMin * 100 * 1.1) / 100
              : Number(lineData) === 0 ? -0.5 :
                lineData > 0
                  ? Math.round(lineData * 100 * 0.9) / 100
                  : Math.round(lineData * 100 * 1.1) / 100
            ,
            dataMax => dataMax > lineData
              ? dataMax === 0 ? 0.5 : Math.round(dataMax * 100 * 1.1) / 100
              : Number(lineData) === 0 ? 0.5 : Math.round(lineData * 100 * 1.1) / 100
          ]}
        />
        <Tooltip
          content={
            <TooltipContent
              prefix={"Team "}
              suffix={suffix}
              showNewLine={true}
              showColon={false}
              prefixFirst={true}
            />
          }
        />
        <CartesianGrid vertical={false} horizontal={false} />
        <Area type="monotone" dataKey="value" stroke={false} strokeWidth={2} fillOpacity={1} fill="url(#colorUv)" />
        <ReferenceLine y={lineData} label={{ position: 'top', value: 'Industry Target', fontSize: 14 }} strokeWidth="2" stroke="#000" />
      </ComposedChart>
      <p>Team</p>
    </ChartContainer>
  );
}

export default ComposedGradientChart;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/components/composed-gradient-chart.js